import { Flex, Typography } from "antd";

import { CustomButton } from "ui";
import { ListStoreConstructor } from "stores/ListStoreConstructor";
import ShapeContent from "images/table/EmptyContentLoupe.svg";

import styles from "../table.module.css";

interface IProps {
  store: ListStoreConstructor<any>;
  hasFiltersApplied: boolean;
}

export const EmptyTable = (props: IProps) => {
  return (
    <Flex vertical gap="large" className={styles.emptyTableContent}>
      <Flex vertical>
        <Flex justify="center">
          <img src={ShapeContent} alt="Технические неполадки" className={styles.toolIcon} />
        </Flex>
        <Typography.Title className={styles.tableErrorMessage}>Ничего не нашлось...</Typography.Title>
        {props.hasFiltersApplied && <Typography.Text>Попробуйте сбросить фильтры и поискать еще раз</Typography.Text>}
      </Flex>
      {props.hasFiltersApplied && (
        <Flex justify="center">
          <CustomButton onClick={() => props.store.removeFilters()} size="middle" type="default">
            Сбросить фильтры
          </CustomButton>
        </Flex>
      )}
    </Flex>
  );
};
